
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/members/[handle]/stats",
      function () {
        return require("private-next-pages/community/members/[handle]/stats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/members/[handle]/stats"])
      });
    }
  